import React from 'react';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { BiLoggerContextProvider } from '../../../biLogger/BiLogger.context';
import TextualThumbBlock from '../../_partials/TextualThumbBlock';
import ContentByUser from '../../_partials/ContentByUser';
var Commissions = function (_a) {
    var commissions = _a.commissions, parentDeviation = _a.parentDeviation, isLoading = _a.isLoading;
    return (React.createElement(BiLoggerContextProvider, { value: { sectionname: 'commissions' } },
        React.createElement(TextualThumbBlock, { streamKey: "commissions", deviations: commissions, useShopThumb: true, parentDeviation: parentDeviation, titleOverride: parentDeviation.author && (React.createElement(ContentByUser, { user: parentDeviation.author, i18nSubKey: "commissions", contentUrl: Url.userShopLink(parentDeviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS), contentTitle: 
                /* this is a bit moot, overridden in translations */ 'Commission' })), maxLength: 1, isLoading: isLoading })));
};
Commissions.displayName = 'Commissions';
export default Commissions;
//# sourceMappingURL=Commissions.js.map